import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { useMutation } from '@tanstack/react-query';
import { JobsService } from 'app/API';
import { notifyApiCallError } from 'app/http/notifyApiCallError';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
  id: string;
};

export const ResubmitJobModal = ({ onCancel, onSuccess, id }: TProps) => {
  const { call } = useAPI();
  const { workspace } = useAuthContext();

  const resubmitMutation = useMutation({
    mutationFn: () => call(() => JobsService.resubmitJobWs({ wsid: workspace?.id ?? '', jobId: id })),
    onSuccess,
    onError: notifyApiCallError,
  });

  return (
    <ModalWrapper width="400px">
      <ModalTitle>Confirm</ModalTitle>
      <p className="m-0 text-center">Are you sure you want to resubmit this job?</p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          resubmitMutation.mutate();
        }}
      >
        <div className="mx-auto flex justify-center w-[300px] gap-2.5">
          <OutlinedButton type="button" onClick={onCancel}>
            Cancel
          </OutlinedButton>
          <Button type="submit" disabled={resubmitMutation.isPending}>
            Resubmit
          </Button>
        </div>
      </form>
    </ModalWrapper>
  );
};
